import React, { useState } from 'react';
import { usePageData } from '../../../../_metronic/layout/core/PageData';
import { useDataTable } from '../../table/DataTable';
import ExportModal from '../../export/components/ExportModal';
import { buildExportFilters } from '../../export/core/_utils';
import { type BackendExport } from '../../export/types';

interface ExportDropdownProps {
  formats: string[];
}

const ExportDropdown: React.FC<ExportDropdownProps> = ({ formats }) => {
  const [showModal, setShowModal] = useState(false);
  const {
    table,
    pageInfo,
    columns,
    exportFields,
    exportColumnKeys,
    exportColumnLabels,
    exportEndpoint,
    exportFilterLabels,
    exportScopes,
    urlFilterLabels,
    listQuery,
    selectedRows,
    selectedRowIds,
    selectedRowsData,
  } = useDataTable();
  const { pageTitle } = usePageData();

  const currentPageRows = table ? table.getRowModel().rows.map((r) => r.original as Record<string, any>) : [];

  const pagination = table?.getState().pagination;
  const tableRowCount = table?.getRowCount() ?? 0;
  const exportItemCount = pageInfo?.exportItemCount ?? tableRowCount;
  const pageItemCount = pageInfo?.pageItemCount ?? currentPageRows.length;

  const pageRange = pagination
    ? (() => {
        const { pageIndex, pageSize } = pagination;
        const start = pageIndex * pageSize + 1;
        const end = start + pageItemCount - 1;
        return `${start}-${end}`;
      })()
    : undefined;

  const backend: BackendExport | undefined = exportEndpoint
    ? {
        endpoint: exportEndpoint,
        query: listQuery,
        filters: buildExportFilters(
          { ...urlFilterLabels, ...listQuery.filter },
          exportFilterLabels ?? {},
          listQuery.search,
        ),
        totalRows: exportItemCount,
        pageIds: currentPageRows.map((row) => String(row.id)),
        // A seleção da `DataTable` atravessa páginas: vão os ids marcados, não só os da página visível.
        selectedIds: selectedRowIds,
        scopes: exportScopes,
      }
    : undefined;

  return (
    <>
      <button aria-label="Exportar" className="btn btn-light-primary" type="button" onClick={() => setShowModal(true)}>
        <span className="me-2 d-none d-md-inline">Exportar</span>
        <i aria-hidden="true" className="bi bi-cloud-arrow-down fs-5" />
      </button>
      <ExportModal
        backend={backend}
        columns={columns}
        currentPageRows={currentPageRows}
        exportableFormats={formats}
        exportColumnKeys={exportColumnKeys}
        exportColumnLabels={exportColumnLabels}
        exportFields={exportFields}
        pageRange={pageRange}
        pageTitle={pageTitle}
        selectedRows={selectedRows}
        selectedRowsData={selectedRowsData}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};

export default ExportDropdown;
